var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "accordeon";

var DEFAULTS = {
	itemSelector: '',
	closedItemClassName: '',
	itemContentSelector: ''
};

/**
 *
 * @param element
 * @param options
 * @constructor
 */
function Accordeon(element, options) {
	this.element = element;
	this.$t = $(this.element);
	this.$table = null;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;
	this.initialise_();
}

/**
 *
 * @private
 */
Accordeon.prototype.initialise_ = function() {
	this.items = $(this.options.itemSelector, this.$t);
	if (this.items.length < 2) {
		return false;
	}

	this.actualItem = 0;
	this.setInitialState_();
	this.bindEvents_();
};

/**
 *
 * @private
 */
Accordeon.prototype.setInitialState_ = function() {
	var self_ = this;
	$(this.items).each(function(index, item) {

		$(item).data('height', $(self_.options.itemContentSelector, $(item)).outerHeight());

		if (index > 0) {
			$(item).addClass(self_.options.closedItemClassName);
			$(self_.options.itemContentSelector, $(item)).css({
				height: 0,
				overflow: 'hidden'
			});
		}
	});
};

/**
 *
 * @private
 */
Accordeon.prototype.bindEvents_ = function() {
	var self_ = this;
	this.$t.on('click', this.options.itemSelector + ' > h3', function(e) {
		var $item = $(e.currentTarget).parents(self_.options.itemSelector + ':first');
		var clickedItemIndex = $(self_.options.itemSelector, self.$t).index($item);
		if (clickedItemIndex === self_.actualItem) {
			return false;
		}

		$(self_.options.itemContentSelector, self_.items[self_.actualItem]).css({ overflow: 'hidden'}).animate({
			height: 0
		}, 300);
		$(self_.options.itemContentSelector, $item).css({ overflow: 'visible'}).animate({
			height: $item.data('height') + 'px'
		}, 300);
		$item.removeClass(self_.options.closedItemClassName);
		$(self_.items[self_.actualItem]).addClass(self_.options.closedItemClassName);
		self_.actualItem = clickedItemIndex;
		return true;
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new Accordeon(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.accordeon.js